/*eslint-disable no-restricted-globals */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Button, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import './FacilityDetails.scss';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import AffiliatedDoctors from '../doctor-details/AffiliatedDoctors';
import Locations from './Locations';
import { BackArrow } from '../../../../img/findcare/FindCareSVG';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import { CLIENT_TYPES } from 'src/constants';
import APIEndpoints from '../../../../../Member/api/APIEndpoints';
import { axiosInstance } from '../../../../../api/axios';
import FilterModal from '../../../common/filter-modal/FilterModal';
import SearchDetailsSkeleton from '../../skeleton/SearchDetailsSkeleton';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';

const FacilityDetails = ({ data }) => {
  const { id, coord } = useParams();
  //const doctorDetails = useSelector(
  //({ findProvider }) => findProvider.facilityDetails,
  //);
  const location = useLocation();

  const [currMemberType] = useState(location?.state?.memberType);
  const [currMemberOid] = useState(location?.state?.memberOid);

  const isMobileClient = useSelector(({ app }) => {
    return app.clientType === CLIENT_TYPES.MOBILE;
  });
  const dispatch = useDispatch();
  const { procedureForData, networksData } = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchParamsForUI,
  );
  const [show, setShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [locations, setLocations] = useState(false);
  const [affiliatedDoctors, setAffiliatedDoctors] = useState(false);
  const [affiliatedDoctorsList, setAffiliatedDoctorsList] = useState({});
  const [facilityData, setFacilityData] = useState({});
  const [skeletonLoader, setSkeletonLoader] = useState(true);
  const [currentAddressIndex, setCurrentAddressIndex] = useState(0);
  const [addressIndex, setAddressIndex] = useState(0);
  const [serverError, setServerError] = useState(false);
  const navigate = useNavigate();
  const [skeletonLoaderAffliatedDoctors, setSkeletonLoaderAffliatedDoctors] =
    useState(false);
  const [serverErrorAffliatedDoctors, setServerErrorAffliatedDoctors] =
    useState(false);

  const fetchFacilityDetails = async () => {
    try {
      const docDetails = await axiosInstance.get(
        APIEndpoints.getFacilityDetails() +
          id +
          '/useraddress/' +
          coord +
          '/network/' +
          networksData.value +
          '/memberoid/' +
          procedureForData.value +
          '/membertype/' +
          procedureForData.memberType,
      );
      setFacilityData(docDetails?.data?.Response?.FacilityDetails);
      setSkeletonLoader(false);
      setServerError(false);
    } catch (e) {
      setSkeletonLoader(false);
      setServerError(true);
    }
  };

  const fetchFacilityAffiliatedDoctors = async (oid) => {
    setSkeletonLoaderAffliatedDoctors(true);
    setServerErrorAffliatedDoctors(false);
    try {
      const AffiliatedDocDetails = await axiosInstance.get(
        APIEndpoints.getFacilityAffiliatedDoctorsDetails() +
          oid +
          '/useraddress/' +
          coord +
          '/membertype/' +
          currMemberType +
          '/memberoid/' +
          currMemberOid,
      );
      setAffiliatedDoctorsList(AffiliatedDocDetails.data.Response);
      setSkeletonLoaderAffliatedDoctors(false);
      setServerErrorAffliatedDoctors(false);
    } catch (e) {
      setSkeletonLoaderAffliatedDoctors(false);
      setServerErrorAffliatedDoctors(true);
    }
  };

  useEffect(() => {
    if (!id) {
      history.goBack();
    } else {
      setSkeletonLoader(true);
      fetchFacilityDetails();
    }
  }, []);

  const modalOpenHandler = () => {
    setShow(true);
  };

  const modalCloseHandler = () => {
    setShow(false);
    setLocations(false);
    setAffiliatedDoctors(false);
  };

  const onChangeHandler = (e) => {
    setCurrentAddressIndex(e.target.value);
  };

  const changeProviderLocation = () => {
    setAddressIndex(currentAddressIndex);
    modalCloseHandler();
  };

  const locationHandler = () => {
    setModalTitle('Locations');
    setLocations(true);
    modalOpenHandler();
  };

  const affiliatedDoctorsHandler = () => {
    fetchFacilityAffiliatedDoctors(id);
    setModalTitle('Affiliated Doctors');
    setAffiliatedDoctors(true);
    modalOpenHandler();
  };

  const navigateToPreviousRoute = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="find-provider-details-container">
        <div className="dashboard-navbar">
          {skeletonLoader ? (
            <SearchDetailsSkeleton />
          ) : serverError ? (
            <CustomClientError
              ErrorHeading="Something went wrong with the request!"
              ErrorMessage="Please try again."
              CustomClasses="p-0"
            />
          ) : (
            <>
              <Row className="mx-0">
                <GenericButton
                  onClick={navigateToPreviousRoute}
                  variant="link"
                  className="mr-2 pt-3 paragraph-font secondary-2 cursor-pointer provider-location-link btn-link btn p-0 m-0"
                >
                  <BackArrow className="generic-back-arrow" />
                </GenericButton>
                <h1 className="content-header">
                  {facilityData?.FacilityName && facilityData.FacilityName}
                </h1>
              </Row>
              <Row className="row-eq-height mt-3">
                <LeftSection facilityDetails={facilityData} />
                <RightSection
                  locationHandler={locationHandler}
                  affiliatedDoctorsHandler={affiliatedDoctorsHandler}
                  facilityDetails={facilityData}
                  addressIndex={addressIndex}
                />
              </Row>
            </>
          )}
        </div>
      </div>
      {affiliatedDoctors && (
        <FilterModal
          titleLabel={modalTitle}
          isVisible={show}
          onHide={modalCloseHandler}
          showApplyLabel="Close"
          applyFilterHandler={modalCloseHandler}
          customClasses="facility-details-modal"
          showClearFilter={false}
          showBackButton={false}
          showCancel={false}
        >
          <AffiliatedDoctors
            serverError={serverErrorAffliatedDoctors}
            skeletonLoader={skeletonLoaderAffliatedDoctors}
            affiliatedDoctorsList={affiliatedDoctorsList}
          />
        </FilterModal>
      )}

      {locations && (
        <FilterModal
          titleLabel={modalTitle}
          isVisible={show}
          onHide={modalCloseHandler}
          applyFilterHandler={changeProviderLocation}
          customClasses="facility-details-modal"
          showClearFilter={false}
          showBackButton={false}
        >
          <Locations
            facilityDetails={facilityData}
            onChangeHandler={onChangeHandler}
            currentAddressIndex={currentAddressIndex}
          />
        </FilterModal>
      )}
    </>
  );
};

export default FacilityDetails;
